import { useState } from "react";

interface DialogActionServiceType {
  openDialog: boolean;
  buttonAction: () => void;
  openDialogAction: () => void;
}

export default function DialogActionService({ action }: any): DialogActionServiceType {
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const openDialogAction = () => setOpenDialog(true);

  const buttonAction = () => {
    setOpenDialog(false);
    action();
  };

  return { openDialog, buttonAction, openDialogAction };
}

export type { DialogActionServiceType };
